// @flow

import Resource from 'speed-js-core/src/api/Resource';

class PointLayer12Resource extends Resource {
    cables(id: string, query: Object) {
        return this.client._request(`${this._getObjectPath(id)}cables/`, 'GET', query)
            .then((response) => response.data);
    }
}

export default PointLayer12Resource;
